import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/template_protections/blacklist/")({
  beforeLoad: () => {
    throw redirect({ to: "/template_protections/blacklist/self" });
  },
});
